// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vUXM","clinicsSelect":"styles_clinicsSelect__21l9f"};